<template>
  <div>
    <div class="flex gap-1 sm:gap-3 flex-wrap xs:justify-end">
      <button
        class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
        @click="viewFilter">
        <span class="">
          <img src="/assets/icon/sort.svg" alt="" />
        </span>
        Filters
      </button>

      <!-- <button class="btn btn-secondary btn-rounded btn-space float-right" @click="viewExport">
        <span class="icon icon-left mdi mdi-arrow-top-right text-primary"></span> Export
      </button> -->
    </div>
    <div class="table-responsive mt-2">
      <table class="table p-0 m-0 dataTable no-footer min-h-[150px] text-nowrap">
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold" width="15%">Name</th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold text-wrap">SAP Code</th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Created</th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">State</th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Phone</th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Email Address</th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Registration Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px">
                  Please wait while we load your distributor's list
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="m in distributors" :key="m.id" v-else>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
              {{ m.name }}
            </td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">{{ m.code }}</td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">{{ formatDate(m.created) }}</td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">{{ m.state }}</td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">{{ m.phone }}</td>
            <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">{{ m.emailAddress }}</td>
            <td>
              <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                'badge',
                { 'badge-success': m.isOnboarded, 'badge-danger': !m.isOnboarded },
              ]">
                <span class="w-[10px] h-[10px] rounded-[1px]"
                  :style="{ backgroundColor: m.isOnboarded ? '#16a249' : '#EF5253' }"></span>
                <span class="text-[12px] font-normal leading-[16.94px]">{{
                  m.isOnboarded ? "Active" : "Inactive"
                }}</span>
              </span>
            </td>
          </tr>
          <tr v-if="!distributors.length && !loading">
            <td colspan="12">
              <div class="text-center" style="padding-top: 50px">
                <span style="font-size: 4.615rem" class="fa-solid fa-truck text-[#2463EB]"></span>
              </div>
              <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]" style="padding-bottom: 100px">
                You don't have any distributors.
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination :limit="pageSize" :count="pageCount" :page="page" :itemsCount="count" @changePage="gotoPage"
        @changeLimit="changeLimit" />
    </div>
    <!-- export modal -->
    <div class="modal fade colored-header colored-header-primary" id="mod-export" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h3 class="modal-title">Export</h3>
            <button class="close md-close" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body"></div>
          <div class="modal-footer">
            <button style="width: 100px" class="btn btn-secondary" type="button" data-dismiss="modal">
              Cancel
            </button>
            <button style="width: 100px" class="btn btn-primary" type="button">
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- filter modal -->
    <div class="modal fade" id="mod-filter" role="dialog">
      <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
        <div class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]">
              Filter
            </h4>
            <button class="text-2xl text-[#353535] outline-none focus:outline-none" type="button" data-dismiss="modal"
              aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="p-0 m-0">
            <div class="pb-[16px]">
              <label class="text-[#353535] font-medium text-[14px] leading-[20px]">By Status</label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  v-model="filter.status">
                  <option value="nil" selected disabled>Select Preferred Status</option>
                  <option value="">All Distributors</option>
                  <option value="True">Active</option>
                  <option value="False">Inactive</option>
                </select>
              </div>
            </div>
            <!-- <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Manufacturer</label
              >
              <div class="col-12 col-sm-8 col-lg-8">
                <select
                  class="form-control"
                  placeholder="Select an option"
                  v-model="filter.parentId"
                >
                  <option value="0">All Manufacturers</option>
                  <option v-for="m in manufacturers" :key="m.id" :value="m.id">
                    {{ m.text }}
                  </option>
                </select>
              </div>
            </div> -->
            <div class="pb-[16px]">
              <label class="text-[#353535] font-medium text-[14px] leading-[20px]">Other filters</label>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="text" placeholder="Filter by name..." v-model="filter.qry" />
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full mt-[24px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" @click="reset">
              Cancel
            </button>
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" @click="getMerchants">
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import Select2 from "@/components/Select2";
import Pagination from "../components/Pagination.vue";

export default {
  name: "salesuserdistributors",
  components: {
    Select2,
    Pagination,
  },
  created() {
    this.getMerchants();
    //this.getManufacturers();
  },
  watch: {
    "updatingMerchant.hasCredit": function (newVal, oldVal) {
      if (!newVal) {
        this.updatingMerchant.creditLimit = 0;
      }
    },
  },
  data() {
    return {
      filter: {
        status: "0",
        parentId: "0",
        qry: "",
      },
      loading: false,
      manufacturers: [],
      deletingMerchant: {},
      updatingMerchant: {},
      v1: {
        creditLimit: false,
      },
      isBusy: false,
      isBusyModal: false,
      distributors: [],
      count: 0,
      page: 1,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
    };
  },
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    reset() {
      this.filter = {
        status: "0",
        parentId: "0",
        qry: "",
      };
    },
    viewExport() {
      // $("#mod-export").modal("show");
    },
    viewRemove(m) {
      this.deletingMerchant = m;
      $("#mod-delete").modal("show");
    },
    viewCreditLimit(m) {
      this.updatingMerchant = m;
      $("#mod-update").modal("show");
    },
    manageManufacturers(id) {
      this.$router.push("/distributors/" + id + "/parents");
    },
    viewFilter() {
      this.pageNumber = 1;
      $("#mod-filter").modal("show");
    },
    details(id) {
      this.$router.push("/sales-user-distributors/" + id);
    },
    viewProductList(distributorId) {
      this.$router.push("/sales-user-distributor-products/" + distributorId);
    },
    updateStatus() {
      this.isBusyModal = true;
      var data = {
        id: this.deletingMerchant.id,
        active: !this.deletingMerchant.active,
      };

      $("#mod-delete").modal("hide");

      this.$http
        .put("/Accounts/updateStatus/" + data.id, data)
        .then(function (res) {
          this.isBusyModal = false;
          this.getMerchants();
        })
        .catch(function () {
          this.isBusyModal = false;
        });
    },
    updateCreditLimits() {
      this.isBusyModal = true;

      if (this.validate()) {
        var data = {
          id: this.updatingMerchant.id,
          creditLimit: this.updatingMerchant.creditLimit,
          hasCredit: this.updatingMerchant.hasCredit,
        };

        $("#mod-update").modal("hide");

        this.$http
          .put("/Accounts/updateCreditLimits/" + data.id, data)
          .then(function (res) {
            this.isBusyModal = false;
            this.getMerchants();
          })
          .catch(function () {
            this.isBusyModal = false;
          });
      } else {
        this.isBusyModal = false;
      }
    },
    validate() {
      this.v1 = {
        creditLimit: false,
      };
      var isValid = true;

      if (Number(this.updatingMerchant.creditLimit) < 0) {
        this.v1.creditLimit = true;
        isValid = false;
      }

      return isValid;
    },
    async getMerchants() {
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/SalesUsers/getDistributorList?page=" +
          this.pageNumber +
          "&pageSize=" +
          this.pageSize +
          (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
          (this.filter.parentId != "0"
            ? "&parentId=" + this.filter.parentId
            : "") +
          (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
          (this.user.id ? "&userId=" + this.user.id : "")
        )
        .then(function (res) {
          this.distributors = res.data.data;
          // this.page = res.data.page;
          this.pageNumber = res.data.pageNumber;
          this.pageSize = res.data.pageSize;
          this.count = res.data.count;
          this.pageCount = Math.ceil(res.data.count / res.data.pageSize);
          this.hasPrev = res.data.hasPrev;
          this.hasNext = res.data.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function () { });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
      this.loading = false;
    },
    async resendInvite(id) {
      this.isBusy = true;
      this.sendingInvite = true;

      await this.$http
        .post("/Accounts/resendInvite/" + id)
        .then(function (res) {
          this.isBusy = false;
          this.sendingInvite = false;
          if (res.ok) {
            this.$toast.success(res.body, {
              icon: false,
              rtl: false,
            });
          }
        })
        .catch(function () {
          this.isBusy = false;
          this.sendingInvite = false;
        });
    },
    formatDate(date) {
      return moment(date).format("lll");
    },

    async getManufacturers() {
      await this.$http
        .get("/Accounts/getItemList?accountType=Manufacturer")
        .then(function (res) {
          this.manufacturers = res.body;
        })
        .catch(function () { });
    },
    prev() {
      this.pageNumber -= 1;
      this.getMerchants();
    },
    next() {
      this.pageNumber += 1;
      this.getMerchants();
    },

    gotoPage(page) {
      this.pageNumber = page;
      this.getMerchants();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getMerchants();
    },
  },
};
</script>
